import * as baseFetcher from '@octopus/api-commons';
import type * as BaseFetcherTypes from '@octopus/api-commons';

export const setCredentialsProvider = baseFetcher.setCredentialsProvider;

export type ErrorWrapper<TError> = BaseFetcherTypes.ErrorWrapper<TError>;

export type ApiError = BaseFetcherTypes.ApiError;

export type ApiFetcherOptions<TBody, THeaders, TQueryParams, TPathParams> = BaseFetcherTypes.ApiFetcherOptions<TBody, THeaders, TQueryParams, TPathParams>;

export const terminationApiFetch = baseFetcher.apiFetch;
